function readHttpUrl(tag, attribute) {
  const match = String(tag || '').match(new RegExp(`\\b${attribute}\\s*=\\s*(?:\"([^\"]*)\"|'([^']*)'|([^\\s\"'=<>\\x60]+))`, 'i'))
  const value = match && (match[1] || match[2] || match[3])
  if (!value) return ''
  try {
    const url = new URL(value.trim())
    return url.protocol === 'http:' || url.protocol === 'https:' ? url.href : ''
  } catch (_) {
    return ''
  }
}

function getTutorialAction(content) {
  const html = String(content || '')
  const links = html.match(/<a\b[^>]*>/gi) || []
  for (const link of links) {
    const url = readHttpUrl(link, 'href')
    if (url) return { type: 'link', url }
  }

  const video = html.match(/<video\b[^>]*>[\s\S]*?<\/video\s*>/i)
  if (!video) return { type: 'none', url: '' }

  const directUrl = readHttpUrl(video[0].match(/<video\b[^>]*>/i)?.[0], 'src')
  if (directUrl) return { type: 'video', url: directUrl }

  const sources = video[0].match(/<source\b[^>]*>/gi) || []
  for (const source of sources) {
    const url = readHttpUrl(source, 'src')
    if (url) return { type: 'video', url }
  }
  return { type: 'none', url: '' }
}

module.exports = { getTutorialAction }
